<template>
  <div>
    <!-- 二次封装的图片上传组件：选图后自动上传，通过 fileChange 事件回传 URL 数组 -->
    <el-upload
      ref="cjUpload"
      action="#"
      :list-type="type"
      :auto-upload="false"
      :limit="limit"
      :file-list="filearr"
      :on-change="OnChangeUpload"
      :on-exceed="handleExceed"
      :disabled="Isdisabled"
      :class="{ disUoloadSty: noneBtnDealImg }"
      :accept="accept || ''"
      style="width: 95%; border: 2px solid #DCDFE6; padding: 15px 5px 10px; min-width: 165px; border-radius: 8px;"
      :on-remove="handleRemove"
      :show-file-list="type === 'text' ? false : true"
    >
      <el-button v-if="type === 'text'" size="small" type="primary">点击上传</el-button>
      <i v-else slot="default" class="el-icon-plus"></i>

      <!-- 图片卡片：预览 + 删除操作 -->
      <div v-if="type !== 'text'" slot="file" slot-scope="{ file }" style="width: 100%; height: 100%;">
        <el-image class="el-upload-list__item-thumbnail" :src="file.url" fit="fill" style="width: 100%; height: 100%;" :preview-src-list="scrList" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span v-if="!disableds" class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <!-- 预览占位（借助 el-image 的 preview-src-list 触发大图预览） -->
    <el-image ref="scrImg" :src="dialogImageUrl" fit="fill" style="width: 100%; height: 0;" :preview-src-list="scrList" />
  </div>
</template>

<script>
import { uploadFile } from '@/api/api'

export default {
  name: 'CjUpload',
  props: {
    // 允许的文件类型，如 image/*
    accept: { type: String, default: '' },
    // 回显的文件列表 [{ url, name }]
    filearr: { type: Array, default: () => [] },
    // 最大上传数
    limit: { type: Number, default: 1 },
    // 展示类型：picture-card 图片卡片 / text 按钮文本
    type: { type: String, default: 'picture-card' }
  },
  data () {
    return {
      theFileList: [],
      maxLength: 0,
      loadings: null,
      dialogImageUrl: '',
      noneBtnDealImg: false,
      Isdisabled: false,
      disableds: false,
      accessoryList: [],
      fileList: [],
      scrList: []
    }
  },
  watch: {
    filearr: {
      handler (n) {
        this.fileList = n || []
        this.toggleDisable()
      },
      immediate: true,
      deep: true
    },
    fileList () {
      this.toggleDisable()
    }
  },
  methods: {
    // 达到 limit 上限时隐藏上传按钮并禁用
    toggleDisable () {
      if (this.fileList.length >= this.limit) {
        this.Isdisabled = true
        this.noneBtnDealImg = true
      } else {
        this.Isdisabled = false
        this.noneBtnDealImg = false
      }
    },
    openLoading () {
      this.loadings = this.$loading({ lock: true, text: '上传中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    },
    // 选图后自动上传到服务器，上传完成 emit fileChange 回传 URL 数组
    async sureUpload () {
      const tasks = []
      this.accessoryList.forEach(item => {
        if (item.raw && !item.isUpload) {
          const fd = new FormData()
          fd.append('file', item.raw)
          tasks.push(uploadFile(fd))
          item.isUpload = true
        }
      })
      if (!tasks.length) return
      this.openLoading()
      try {
        const res = await Promise.all(tasks)
        const urls = res.map(r => r.data)
        this.$emit('fileChange', urls)
      } catch (e) {
        // 错误提示已由请求拦截器统一处理
      } finally {
        if (this.loadings) this.loadings.close()
      }
    },
    // 文件校验：重名拦截后触发上传
    uploadFilesVerification (file, fileList) {
      const existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name)
      if (existFile) {
        this.$message.error('当前文件已经存在!')
        fileList.pop()
        return
      }
      this.accessoryList = fileList
      this.fileList = fileList
      this.sureUpload()
    },
    // 选择文件回调（防抖：合并多次 change 后统一上传）
    OnChangeUpload (file, fileList) {
      this.maxLength = Math.max(fileList.length, this.maxLength)
      const theFile = file
      theFile.isUpload = false
      this.theFileList.push(theFile)
      setTimeout(() => {
        if (fileList.length === this.maxLength) {
          this.uploadFilesVerification(file, this.theFileList)
        }
      }, 100)
    },
    handleRemove (file) {
      let idx = this.fileList.findIndex(item => item.url === file.url)
      if (idx === -1) idx = this.fileList.findIndex(item => item.uid === file.uid)
      if (idx !== -1) {
        const removed = this.fileList.splice(idx, 1)[0]
        this.theFileList.splice(idx, 1)
        this.$emit('removeAfter', removed ? removed.url : file.url)
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.scrList = this.fileList.map(item => item.url)
      this.$refs.scrImg.clickHandler()
    },
    handleExceed (files) {
      const val = this.limit - this.fileList.length
      if (val < files.length) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件，一共选择了 ${files.length + this.fileList.length} 个文件`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disUoloadSty ::v-deep .el-upload--picture-card {
  display: none;
}
</style>
